// MessageTemplateModal.ts
//
// Só o que a casca (`_casca.ts`) não tem: a linha de chips das variáveis e a
// caixa da prévia. Tudo o mais do modal (overlay, seções, inputs, botões) vem de
// lá — duplicar aquilo é o que fez nascer as seis folhas quase iguais que o
// comentário do `_casca` documenta.
//
// Tokens: só `var(--u)`, `var(--fs-*)` e `var(--sp-*)`.
import styled from "styled-components";

/** A fila de `{variavel}` derivadas do texto. Quebra linha em template longo. */
export const LinhaDeChips = styled.div`
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: var(--sp-6);
  margin-top: var(--sp-8);
`;

/**
 * A prévia do template com valores de exemplo.
 *
 * `white-space: pre-wrap` não é enfeite: o template de e-mail tem `\n` de
 * verdade (assinatura, linha em branco entre parágrafos). Sem isso a prévia
 * mostraria tudo numa linha só e esconderia justamente o erro de formatação que
 * ela existe para pegar.
 */
export const PreviaCaixa = styled.div`
  margin-top: var(--sp-8);
  padding: var(--sp-12);
  border-radius: 8px;
  border: 1px dashed #cbd6e0;
  background: #f4f7f9;
  color: #3d4d5c;
  font-size: var(--fs-sm);
  line-height: 1.5;
  white-space: pre-wrap;
  word-break: break-word;
  max-height: calc(var(--u) * 220);
  overflow-y: auto;
`;

/** A legenda que impede a prévia de ser lida como dado real. */
export const PreviaLegenda = styled.div`
  display: flex;
  align-items: center;
  gap: var(--sp-6);
  margin-top: var(--sp-8);
  font-size: var(--fs-2xs);
  color: #6c757d;
`;
